'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _item = require('./remote/item');

var Item = {
    fetchBuyNowsByIds: _item.ItemRemote.fetchBuyNowsByIds,
    fetchItemsByIds: _item.ItemRemote.fetchItemsByIds,
    fetchItemShippingsByIds: _item.ItemRemote.fetchItemShippingsByIds,
    fetchListingAgentsByIds: _item.ItemRemote.fetchListingAgentsByIds
};

exports.default = Item;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/item.js
// module id = lSbF
// module chunks = 60